import { Link } from 'gatsby'
import { Button } from 'nzk-react-components'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  min-height: 40vh;
  z-index: 0;
  background-color: #07031f;
  margin-top: -90px;
  padding-top: 20px;
  padding-bottom: 100px;


  h2 {
    text-align: center;
    color: #fff !important;
    font-size: 2.2em;
    margin-bottom: 20px;
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 0 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > .content--description {
      color: #fff;
      max-width: 500px;
      margin: 0 auto;
      text-align: center;
    }
  }

  .awards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1260px;
    margin: 0 auto;
    margin-top: 50px;
    gap: 3em;

    margin-bottom: 30px;
  }

  .award {
    color: #fac348;
    font-family: Nunito;
    display: flex;

    .award--content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 5px;
      gap: 12px;
      white-space: pre-wrap;
      text-align: center;
      width: 200px;
    }
    .award--title {
      font-weight: 900;
    }
    .award--name {
      font-size: 0.9em;
    }
    .award--image {
      height: 80px;
      width: 80px;
      display: flex;
      justify-content: center;
      margin: 0 auto;

      background-color: #341644;
      background-image: radial-gradient(circle at center, #000a46 0%, #572771 100%);
      box-shadow: 4px 4px 0 #572771;
      border-radius: 50%;
      img {
        height: 100%;
      }
    }
  }

  .left-wreath, .right-wreath {
    display: flex;
    align-items: center;
  }


  @media screen and (max-width: 820px) {
    margin-top: 0px;
  }

`

export const ParentsV2_Awards = (props: {
  description?: string
  awards: {
    title: string
    name: string
    img?: ReactElement
  }[]
  cta?: {
    label: string
    url: string
  }
}) => {
  return <Wrapper>
    <div className='content'>
      <h2>Our Awards</h2>
      {props.description && <div className='content--description'>{props.description}</div>}
      <div className='awards'>
        {props.awards.map((award, i) => {
          return <div key={i} className='award'>
            <div className='left-wreath'>
              <img src='/images/parents-v2/award-wreath-l.svg' />
            </div>
            <div className='award--content'>
              <div className='award--title'>{award.title}</div>
              <div className='award--image'>{award.img}</div>
              <div className='award--name'>{award.name}</div>
            </div>

            <div className='right-wreath'>
              <img src='/images/parents-v2/award-wreath-r.svg' />
            </div>
          </div>

        })}
      </div>

      {props.cta && <div className='cta'>
        <Link to={props.cta.url}>
          <Button theme='primary'>{props.cta.label}</Button>
        </Link>
      </div>}
    </div>
  </Wrapper>
}
